import { stripHTML } from './strip';
/* eslint-disable */
(function ({ theme }) {
  /**
   * Overridable theme function when there are no results.
   */
  // @todo: WHY. add to template
  theme.searchApiLunrNoResults = Drupal.theme.searchApiLunrNoResults || function () {
    let searchTerm = document.getElementById('search-term-page').value;
    if (searchTerm === undefined) {
      searchTerm = document.getElementById('search-term-overlay').value;
    }

    const langCode = drupalSettings.language;
    return `<div class="sp-results">
          <div class="view-empty">
            <h4>${Drupal.t("We’re sorry. Unfortunately, we were not able to find any matches for")} '<span class="search-keyword">${searchTerm}</span>'.
            <span class="br">${Drupal.t("Try a different search term or take a look at some of our suggestions below.")}</span></h4>
            <div class="empty-suggestions">
              <p>${Drupal.t("If you can't find what you are looking for, please feel free to ")}<a href="/${langCode}/contact">${Drupal.t("contact us")}</a>.</p>
              <ul class="os-nav">
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/">${Drupal.t('Home')}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/naval-vessels">${Drupal.t('Naval Vessels')}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/career">${Drupal.t('Career')}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/about-us">${Drupal.t("NVL")}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/coast-guard-vessels">${Drupal.t("Coast Guard Vessels")}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/media">${Drupal.t("Media")}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/shipyards-and-docks">${Drupal.t("Shipyards and Docks")}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/nvl-services">${Drupal.t("NVL Services")}</a></li>
                <li><i class="far fa-chevron-right os-icon"></i><a href="/${langCode}/contact">${Drupal.t("Contact")}</a></li>
              </ul>
            </div>
          </div>
      </div>`;
  };

  /**
   * Overridable theme function for the search results summary.
   */
  theme.searchApiLunrResultSummary = Drupal.theme.searchApiLunrResultSummary || function (pagination) {
    return '';
  };

  /**
   * Overridable theme function for the search results.
   */
  theme.searchApiLunrResult = Drupal.theme.searchApiLunrResult || function (doc) {
    let build = ['<div class="search-api-lunr-teaser sp-result hidden">'];
    build.push(`<h4 class="spr-title"><a href="${doc.getUrl()}">${doc.getLabel()}</a></h4>`);
    const rendered_item = doc.rawDocument.rendered_item;

    // Remove style tag that could be added from Misc.
    let text = rendered_item.replace(/(<style[\w\W]+style>)/g, "");
    // Remove html tags.
    text = stripHTML(text).replace(/\s\s+/g, ' ');

    let searchTerm = document.getElementById('search-term-page').value;
    if (searchTerm === undefined) {
      searchTerm = document.getElementById('search-term-overlay').value;

    }
    if (text) {
      const description = getExcerpt(text, searchTerm, 350);
      build.push(`<div class="spr-body">${description.shortText}</div>`);
    }
    build.push('</div>');
    return build.join('');
  };

})(window.Drupal);

/**
 * Make short description with highlighted search term.
 */
function getExcerpt(text, searchTerm, limit) {
  let highlightedText = text.replaceAll(new RegExp(searchTerm, "gi"), (match) => `<strong>${match}</strong>`);
  const fullLength = text.length;

  let shortText = highlightedText;
  if (fullLength > limit) {
    const getIndexes = getIndexesOf(searchTerm, text);
    if (getIndexes[0] >= limit) {
      shortText = shortText.substr(shortText.lastIndexOf('.', getIndexes[0]) + 1,
        shortText.lastIndexOf(' ', limit)) + '...';
    }
    if (getIndexes[0] < limit) {
      shortText = shortText.substr(0, shortText.lastIndexOf(' ', limit)) + '...';
    }
    else {
      shortText = shortText.substr(0, shortText.lastIndexOf(' ', limit)) + '...';
    }
  }
  const rawText = shortText.replace(/<\/?[^>]+(>|$)/g, "");
  const rawRemovedDups = removeDuplicates(rawText)
    .replaceAll(new RegExp(searchTerm, "gi"), (match) => `<strong>${match}</strong>`);

  return {
    shortText: rawRemovedDups
  };
}

/**
 * Get indexes of all the searched word.
 */
function getIndexesOf(searchStr, str, caseSensitive) {
  const searchStrLen = searchStr.length;
  if (searchStrLen === 0) {
    return [];
  }
  let startIndex = 0, index, indices = [];
  if (!caseSensitive) {
    str = str.toLowerCase();
    searchStr = searchStr.toLowerCase();
  }
  while ((index = str.indexOf(searchStr, startIndex)) > -1) {
    indices.push(index);
    startIndex = index + searchStrLen;
  }
  return indices;
}

function removeDuplicates(textToRemove) {
  var temp = textToRemove;
  var array = temp.split(" ");
  array.sort();
  temp = array.join(" ");
  do {
    var newTemp = temp;
    var temp = newTemp.replace(/\s(\w+\s)\1/, " $1");
  } while (temp.length != newTemp.length);
  temp = temp.replace(/^(\w+\s)\1/, "$1");
  temp = temp.replace(/(\s\w+)\1$/, "$1");
  var orig = textToRemove.split(" ");
  var finalStr = "";
  for (var i = 0; i < orig.length; i++) {
    if (temp.indexOf(" " + orig[i] + " ") != -1) {    // in the middle
      finalStr += orig[i] + " ";
      temp = temp.split(" " + orig[i] + " ").join(" ");
    } else if ((temp.indexOf(orig[i]) != -1) && (temp.indexOf(" " + orig[i]) == (temp.length - orig[i].length - 1))) {   // At the end
      finalStr += orig[i] + " ";
      temp = temp.substring(0, (temp.length - orig[i].length - 1));
    } else if (temp.indexOf(orig[i] + " ") == 0) {    // at the start
      finalStr += orig[i] + " ";
      temp = temp.substring(orig[i].length + 1, temp.length);
    } else if (temp == orig[i]) {    // exact match
      finalStr += orig[i];
      temp = "";
    }
  }
  if (finalStr.substring(finalStr.length - 1, finalStr.length) == " ") {
    finalStr = finalStr.substring(0, finalStr.length - 1);
  }

  return finalStr;
}
